import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  get () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}crew`, AUTH_HEADERS())
  },
  create(crew) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}crew`, crew, AUTH_HEADERS())
  },
  update (crew) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}crew/update`, crew, AUTH_HEADERS())
  },
  getCrewUsers (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}crew/${id}/users`, AUTH_HEADERS())
  },
  getCrewTasks (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}crew/${id}/tasks`, AUTH_HEADERS())
  },
  delete (id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}crew/delete/${id}`, AUTH_HEADERS())
  }
}
